import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/style.css';
// import './css/layers.css';
// import './css/navigation.css';
// import './css/settings.css';
import './css/animate.css';
import './css/flaticon_taxi.css';
import './css/fontawesome.css';
import './css/linear.css';
import './css/odometer-theme-default.css';
import './css/owl.css';
import './css/select2.min.css';
import './css/swiper.min.css';
import './css/tm-bs-mp.css';
import './css/tm-utility-classes.css';
// import $ from  'jquery';
// import 'bootstrap/dist/css/bootstrap.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
